import React from 'react';
import moment from 'moment';

import {
  AsyncSelectField,
  AutoCompleteField,
  Avatar,
  CloseBtn,
  MCButton,
  MCError,
  SelectField,
  Spinner,
  TextField,
  ToggleSwitch
} from 'src/components/basic';
import { DateSelects, MCDatePicker, popupModel } from 'src/components/complex';
import SVGIcon from 'src/components/svg';
import BaseComponent from 'src/components/BaseComponent';

import constants from 'src/constants';

import {
  remCss,
  lang,
  withRouter,
  scssVariables as variables,
  userFullName,
  addressObject,
  objectToSelectList
} from 'src/helpers';

import model from '../modifyModel';
import AddPatientSlot from './AddPatientSlot';
import ShortInfo from 'src/components/user/ShortInfo';
import LANG_CONST from 'src/helpers/lang/const';
import AlertManager from 'src/components/alert/AlertManager';
import { EmailPhoneSection, FormRow } from 'src/components/Form';

class AddAdvance extends BaseComponent {
  state = { more: false, saved: false };

  componentDidMount() {
    const model = this.getModel();
    model.subscribe(this.subscription);
    this.setState({ saved: false });
  }

  componentWillUnmount() {
    const model = this.getModel();
    model.unsubscribe(this.subscription);
  }

  getModel = () => {
    return this.props.model || model;
  };
  add = (e) => {
    const model = this.getModel();
    e.preventDefault();
    this.setState({ saved: false });
    model.sendInvite(this.props.router.params.id, (err, data, success) => {
      if (success) {
        if (this.props.isEdit) {
          return this.setState({ saved: true });
        }
        AlertManager.popup(AlertManager.TYPES.INFO, {
          close: false,
          width: 400,
          title: lang.t(LANG_CONST.notice.sent_invitation, {
            type: lang.t(LANG_CONST.patient).toLowerCase()
          }),
          actionButton: {
            label: LANG_CONST.buttons.ok,
            action: (actions) => {
              actions.hide();
            }
          }
        });
        this.back();
      }
    });
  };

  render() {
    const model = this.getModel();
    const apiStateId = this.props.isEdit ? 'updatePatient' : 'inviteAdvance';
    const createState = model.getApiState(apiStateId);
    const { invalid } = createState;
    const address = addressObject(model.state);

    if (createState.error === 'EMAIL_TAKEN') {
      invalid['email'] = createState.errorMessage;
      createState.error = '';
    }
    if (createState.error === 'PHONENUMBER_TAKEN') {
      invalid['phoneNumber'] = createState.errorMessage;
      createState.error = '';
    }
    return (
      <>
        <div className={'mc-container-content__body-content border'}>
          <div className={'mc-form'} style={{ flexWrap: 'wrap' }}>
            <div className={'mc-flex-col mc-grow'}>
              {createState.error && (
                <div className={'mc-flex'}>
                  <p className='mc-error'>{createState.errorMessage}</p>
                </div>
              )}
              <FormRow className={'mc-flex-20 mc-flex-start'}>
                <TextField
                  template={6}
                  label={LANG_CONST.first_name}
                  name={'firstName'}
                  placeholder={lang.t(LANG_CONST.text.enter, {
                    attr: lang.t(LANG_CONST.patient_first_name).toLowerCase()
                  })}
                  value={model.input('firstName')}
                  onChange={(n, v) => {
                    model.resetApiState(this.apiStateId);
                    model.handleChange(n, v);
                  }}
                  onBlur={model.handleBlur}
                  invalid={invalid}
                />
                <TextField
                  template={6}
                  label={LANG_CONST.last_name}
                  name={'lastName'}
                  placeholder={lang.t(LANG_CONST.text.enter, {
                    attr: lang.t(LANG_CONST.patient_last_name).toLowerCase()
                  })}
                  value={model.input('lastName')}
                  onChange={(n, v) => {
                    model.resetApiState(this.apiStateId);
                    model.handleChange(n, v);
                  }}
                  onBlur={model.handleBlur}
                  invalid={invalid}
                />
              </FormRow>

              <EmailPhoneSection
                defaultCountryName={model.state.tempCountryAddress}
                email={model.input('email')}
                handleChangeProfile={(n, v) => {
                  model.resetApiState(apiStateId);
                  model.handleChange(n, v);
                }}
                handleBlur={model.handleBlur}
                phoneNumber={model.input('phoneNumber').toString()}
              />
              {invalid?.emailOrPhone && (
                <MCError mcTextProps={{ primary: true }} error={invalid?.emailOrPhone} />
              )}
              <FormRow addColspan={1}>
                <SelectField
                  template={6}
                  width={'100%'}
                  options={objectToSelectList(LANG_CONST.constants.gender)}
                  label={LANG_CONST.gender}
                  isSearchable={false}
                  name={'gender'}
                  value={model.input('gender')}
                  onChange={(n, v) => {
                    model.resetApiState(apiStateId);
                    model.handleChange(n, v);
                  }}
                  invalid={invalid}
                />
              </FormRow>
              <div className={'mc-flex-20 mc-flex-start'}>
                <div className={'mc-flex-col mc-grow'}>
                  <div className={'mc-label-418'}>{lang.t(LANG_CONST.date_of_birth)}</div>
                  <FormRow>
                    <DateSelects
                      close={false}
                      className={'mc-flex-20 mc-user-birthday'}
                      template={6}
                      minDate={moment().startOf('year').year(1900)}
                      maxDate={moment().add({ years: -14 }).endOf('year')}
                      onChange={(n, v) => {
                        model.resetApiState(apiStateId);
                        model.handleChange(n, v);
                      }}
                      invalid={invalid}
                      name={'birthday'}
                      date={model.input('birthday')}
                    />
                  </FormRow>

                  {invalid['birthday'] && (
                    <MCError error={invalid['birthday']} label={LANG_CONST.date_of_birth} />
                  )}
                </div>
              </div>
              <div className={'mc-title'}>{lang.t('Contact information')}</div>
              <FormRow>
                <TextField
                  template={6}
                  label={LANG_CONST.address.address}
                  name={'address'}
                  placeholder={''}
                  value={model.input('address')}
                  onChange={(n, v) => {
                    model.resetApiState(apiStateId);
                    model.handleChange(n, v);
                  }}
                  onBlur={model.handleBlur}
                  invalid={invalid}
                />
              </FormRow>
              <FormRow>
                <AutoCompleteField
                  template={6}
                  label={LANG_CONST.address.country}
                  name={'countryAddress'}
                  value={model.input('countryAddress')}
                  onChange={(n, v) => {
                    model.resetApiState(apiStateId);
                    if (model.input('countryAddress') !== v) {
                      model.handleChange(n, v);
                      model.handleChange('stateAddress', '');
                      model.handleChange('cityAddress', '');
                    }
                  }}
                  autocompleteApi='country'
                  autocompleteParams={{
                    limit: 300
                  }}
                  invalid={invalid}
                />
                <AutoCompleteField
                  template={6}
                  label={LANG_CONST.address.state}
                  name={'stateAddress'}
                  value={model.input('stateAddress')}
                  onChange={(n, v) => {
                    model.resetApiState(apiStateId);
                    model.handleChange(n, v);
                    model.handleChange('cityAddress', '');
                  }}
                  invalid={invalid}
                  autocompleteParams={{
                    countryCode: address.countryCode,
                    limit: 100
                  }}
                  autocompleteApi='state'
                />
                <AutoCompleteField
                  template={6}
                  label={LANG_CONST.address.city}
                  name={'cityAddress'}
                  value={model.input('cityAddress')}
                  onChange={(n, v) => {
                    model.resetApiState(apiStateId);
                    model.handleChange(n, v);
                  }}
                  invalid={invalid}
                  autocompleteApi='city'
                  autocompleteParams={{
                    countryCode: address.countryCode,
                    stateCode: address.stateCode,
                    limit: 20
                  }}
                />
              </FormRow>
              <FormRow addColspan={2}>
                <TextField
                  template={6}
                  label={LANG_CONST.address.zip}
                  name={'zipcode'}
                  value={model.input('zipcode')}
                  onChange={(n, v) => {
                    model.resetApiState(apiStateId);
                    model.handleChange(n, v);
                  }}
                  onBlur={model.handleBlur}
                  invalid={invalid}
                />
              </FormRow>
            </div>
            {!this.props.disabledRight && (
              <div className={'mc-form-right'}>
                <div className={'mc-flex'}>
                  <div className={'mc-grow mc-title'}>{lang.t('Schedule appointment')}</div>
                  <ToggleSwitch
                    checked={model.input('scheduleFlg')}
                    onChange={() => model.handleChange('scheduleFlg', !model.input('scheduleFlg'))}
                  />
                </div>
                {model.input('scheduleFlg') && (
                  <>
                    {model.state.user?.isClinic && (
                      <AsyncSelectField
                        template={6}
                        isClearable={false}
                        placeholder={'Doctor'}
                        defaultValue={true}
                        apiConfig={{
                          url: 'clinic/doctor/list',
                          joined: true,
                          labelFn: (user) => <ShortInfo small user={user} specialist={[]} />
                        }}
                        name={'doctorId'}
                        invalid={invalid}
                        value={model.input('doctorId')}
                        onChange={(n, v) => {
                          model.handleChange('doctorId', v);
                          model.selectedMonth(model.state.selectedDate);
                        }}
                      />
                    )}
                    <MCDatePicker
                      selected={model.input('selectedDate')}
                      isSmall={true}
                      minDate={moment()}
                      onChange={model.selectedDay}
                      onSetMonth={model.selectedMonth}
                      onClassNamesOfCell={(day, classNames) => {
                        if (
                          model.state.slotsMonth.find(
                            (s) =>
                              s.startDate >= day.clone().startOf('day') &&
                              s.startDate <= day.clone().endOf('day')
                          )
                        ) {
                          classNames.push('available');
                        }
                      }}
                    />
                    <div className={'mc-title'}>{lang.t('Time')}</div>
                    {model.state.slots
                      .slice(0, this.state.more ? model.state.slots.length : 5)
                      .map((s, i) => {
                        const slot =
                          s.id !== model.state.selectedSlot?.id
                            ? s
                            : {
                                ...model.state.selectedSlot,
                                patientId: 'temp',
                                firstName: model.state.firstName || '',
                                lastName: model.state.lastName || ''
                              };
                        return (
                          <div className={'mc-flex-col'} key={i}>
                            <div className={'mc-title'}>
                              {moment(slot.startDate).format('hh:mm a')}
                            </div>
                            {!slot.patientId && (
                              <div
                                className={'mc-slot available mc-no-style-btn'}
                                onClick={() => {
                                  popupModel.setActivePopup('add_patient_slot', {
                                    active: true,
                                    component: AddPatientSlot,
                                    props: { item: slot, index: i }
                                  });
                                }}
                              >
                                <div className={'mc-flex'}>
                                  <div className={'mc-icon'}>
                                    <SVGIcon
                                      iconname={'plus-icon'}
                                      width={12}
                                      fill={variables['colors-mc-text-primary']}
                                    />
                                  </div>
                                  <div>{lang.t('Add Patient')}</div>
                                </div>
                              </div>
                            )}
                            {!!slot.patientId && (
                              <div className={'mc-slot ' + slot.appointmentType}>
                                {slot.patientId === 'temp' && (
                                  <CloseBtn
                                    onClose={() => model.setState({ selectedSlot: null })}
                                    width={20}
                                    style={{
                                      position: 'absolute',
                                      right: remCss(15),
                                      top: remCss(15)
                                    }}
                                  />
                                )}
                                <div className={'mc-flex'}>
                                  {constants.general.appointment_types
                                    .filter((i) => slot.appointmentType === i.value)
                                    .map((i) => (
                                      <div className={'mc-tag'} key={i.value}>
                                        {lang.t(i.label)}
                                      </div>
                                    ))}
                                </div>

                                <div className={'mc-flex'}>
                                  <Avatar
                                    image={slot.avatar}
                                    text={slot.firstName}
                                    width={40}
                                    height={40}
                                  />
                                  <div className={'mc-title'}>{userFullName(slot)}</div>
                                </div>
                                {slot.hospital && (
                                  <div className={'mc-flex'}>
                                    {slot.hospital?.split('_')[0]}{' '}
                                    {addressObject(slot).fullAddressName}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </>
                )}
                {model.getApiState('list').loading ? (
                  <div>
                    <Spinner />
                  </div>
                ) : (
                  model.input('scheduleFlg') && (
                    <>
                      {model.state.slots.length > 5 && (
                        <div className={'mc-flex'}>
                          <div className={'mc-grow'}></div>
                          <div
                            className={'mc-more'}
                            onClick={() => this.setState({ more: !this.state.more })}
                          >
                            <span className={'mc-char'}>{!this.state.more ? '+' : '-'}</span>
                            &nbsp;&nbsp;
                            {lang.t(!this.state.more ? 'Show more' : 'Show less')}
                          </div>
                        </div>
                      )}
                      {model.state.slots.length === 0 && (
                        <div style={{ textAlign: 'center' }}>{lang.t('No available slot.')}</div>
                      )}
                    </>
                  )
                )}
                <div>&nbsp;</div>
              </div>
            )}
          </div>
        </div>
        <div className={'mc-container-content__body-footer'}>
          <div className={'mc-flex'}>
            <div className={'mc-grow'}></div>
            <MCButton
              primary
              dark
              radius
              medium
              disabled={createState.loading}
              loading={createState.loading}
              onClick={this.add}
              style={{ width: remCss(200) }}
              label={
                this.props.isEdit
                  ? this.state.saved
                    ? LANG_CONST.saved
                    : LANG_CONST.buttons.save
                  : LANG_CONST.buttons.send_invite
              }
            />
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(AddAdvance);
